import { CaseDataManagerSchema, CaseTemplate } from 'dashboard/models/case-template';
import { CaseVariableDefinition } from 'dashboard/models/case-variable-definition';
import { CaseTemplateActions, CaseTemplateActionType } from 'dashboard/redux/actions/case-template';

export interface CaseTemplateState {
  caseTemplate: CaseTemplate | undefined;
  caseDataManagerSchema: CaseDataManagerSchema | undefined;
  caseVariableDefinitions: CaseVariableDefinition[] | undefined;
}

export const initialState: CaseTemplateState = {
  caseTemplate: undefined,
  caseDataManagerSchema: undefined,
  caseVariableDefinitions: undefined,
};

const caseTemplateReducer = (
  state: CaseTemplateState = initialState,
  action: CaseTemplateActions,
): CaseTemplateState => {
  switch (action.type) {
    case CaseTemplateActionType.ClearCaseTemplate: {
      return initialState;
    }

    case CaseTemplateActionType.SetCaseTemplate: {
      return {
        ...state,
        caseTemplate: action.payload.caseTemplate,
      };
    }

    case CaseTemplateActionType.SetCaseDataManagerSchema: {
      return {
        ...state,
        caseDataManagerSchema: action.payload.caseDataManagerSchema,
      };
    }

    default:
      return state;
  }
};

export default caseTemplateReducer;
